
export default {

    settings(state){
        return state.settings
    },

    setting(state){
        return state.setting
    },

    referralBonusSetting(state){
       return state.referralBonusSetting
    }
}